import { useState } from "react"
import { GameSelect } from "../GameSelect"
import { Button, Card } from "antd"
import { BoardGameSearchEntry, Event } from "../../api.types"
import { useHttp } from "../../Context"
import { EventHeader } from "../eventView/EventHeader"

export function EventPropositionsForm(props: { event: Event, eventId: string, gamePropositionCount: number, onSend: () => any }): (JSX.Element | null) {
    const [games, setGames] = useState((props.event.myPropositions || []) as BoardGameSearchEntry[])
    const [notes, setNotes] = useState((props.event.myPropositions || []).map(v => v.note) as string[])
    const [sending, setSending] = useState(false)
    const httpFetch = useHttp()

    const sendPropositions = () => {
        if (sending) {
            return;
        }
        setSending(true)
        httpFetch(`/api/event/${props.eventId}/propositions`, {
            method: "PUT",
            body: JSON.stringify(games.filter((v) => !!v).map((g: any, idx: number) => ({ id: g.id, name: g.name, note: notes[idx] })))
        }, {successNotification: "Saved"}).then(() => { setSending(false); props.onSend() })
    }
    const setGame = (idx: number): ((game: any) => any) => {
        return (game: any) => {
            const copy = ([] as BoardGameSearchEntry[]).concat(games)
            copy[idx] = game
            setGames(copy)
        }
    }
    const setGameNote = (idx: number): ((note: string) => any) => {
        return (note: string) => {
            const copy = ([] as string[]).concat(notes)
            copy[idx] = note
            setNotes(copy)
        }
    }

    const selects: JSX.Element[] = [];
    for (let i = 0; i < props.gamePropositionCount; i++) {
        selects.push(
            <div key={i} style={{ margin: 6 }}>
                <label>Gra dla 2+ graczy </label>
                <GameSelect value={games[i]} note={notes[i]} onChange={setGame(i)} onNoteChange={setGameNote(i)}/>
            </div>
        )
    }
    return (
        <Card>
            <EventHeader event={props.event}/>
            <h3>Gry które możesz wziąć w przyszłym tygodniu</h3>
            {selects}
            <Button type="primary" onClick={sendPropositions} size="large" disabled={sending}>Wyślij</Button>
        </Card>
    )
}
